import { Stack, Text } from '@solvhealth/jigsaw-v1';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { analyticsTrackEvent } from '~/core/analytics';
import {
  DRAWER_TYPE_TRIAGE,
  NAV_TILE_CLICKED,
  TRIAGE_ENTRYPOINT_ACCOUNT_HOME,
  TRIAGE_ENTRYPOINT_CLICKED,
  TRIAGE_ENTRYPOINT_SEEN,
} from '~/core/analytics/events';
import { RemixRoutes } from '~/core/remix';
import { useObserveVisibility } from '~/hooks/useObserveVisibility';
import { useTrackNavTile } from '../../hooks/useTrackNavTile';
import { Details, Icon, Root, SubTitle, Title } from '../../styles';
import { ServiceCategoryPageNameForAnalytics } from '~/components/Services/ServiceCategoryPage';
import { ServiceCategoriesListPageNameForAnalytics } from '~/components/Services/ServiceCategoriesListPage';
import { isUserProfileAMinor } from '~/core/util/userProfile';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';

type Props = {
  entrypoint:
    | typeof TRIAGE_ENTRYPOINT_ACCOUNT_HOME
    | ServiceCategoriesListPageNameForAnalytics
    | ServiceCategoryPageNameForAnalytics;
};
const Triage = ({ entrypoint }: Props) => {
  const onClick = () => {
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      type: DRAWER_TYPE_TRIAGE,
    });
    analyticsTrackEvent(TRIAGE_ENTRYPOINT_CLICKED, { entrypoint });
  };

  useTrackNavTile('triage');

  const { t } = useTranslation(['account', 'common']);

  const ref = useRef<HTMLDivElement>();
  const isMinor = isUserProfileAMinor(useSelectActiveUserProfile());

  useObserveVisibility<HTMLDivElement>(ref, () => {
    analyticsTrackEvent(TRIAGE_ENTRYPOINT_SEEN, {
      entrypoint,
    });
  });

  return (
    // Styled components makes the ref typing tricky so we erase here
    <Root href={RemixRoutes.triage} onClick={onClick} ref={ref as any}>
      <Icon alt="Clipboard" src="/images/account/tiles/triage-new.svg" />
      <Details>
        <Stack alignItems="center" row space={1}>
          <Title>
            {t(isMinor ? 'account:navTiles.kids.triage.title' : 'account:navTiles.triage.title')}
          </Title>
        </Stack>
        <SubTitle>
          {t(
            isMinor ? 'account:navTiles.kids.triage.subtitle' : 'account:navTiles.triage.subtitle'
          )}
        </SubTitle>
      </Details>
    </Root>
  );
};

export default Triage;
